export const getObjectValueByKey = (obj, key) => key.split('.').reduce((o, k) => o?.[k], obj);
